module.exports = __webpack_public_path__ + "static/media/flag_for_page7a.0372b199.png";